// Sample images

// Patterns
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import EMSATrainingPrograms from './components/EMSATrainingPrograms/EMSATrainingPrograms';

// Route mapping for direct tab access
const ROUTE_CONFIG = {
  // Page 1: EMS Training Programs
  '/continuing-education': { page: 1, tab: 0, name: 'Continuing Education' },
  '/emspersonnel': { page: 1, tab: 1, name: 'EMS Personnel' },
  '/public-safety-first-aid': { page: 1, tab: 2, name: 'Public Safety First Aid' },
  
  // Page 2: General Training Programs  
  '/epinephrine-auto-injector': { page: 2, tab: 0, name: 'Epinephrine Auto-Injector' },
  '/childcare-cpr-first-aid': { page: 2, tab: 1, name: 'Child Care Provider CPR and First Aid' },
  '/childcare-preventive-health': { page: 2, tab: 2, name: 'Child Care Provider Preventive Health & Safety' },
  '/schoolbusdriver': { page: 2, tab: 3, name: 'School Bus Driver First Aid' },
  
  // Page routes
  '/ems-training': { page: 1, tab: 0, name: 'EMS Training Programs' },
  '/general-training': { page: 2, tab: 0, name: 'General Training Programs' }
};

function App() {

  return (
    <Router>
      <div className={'main-content'} id={'main-content'}>
        <main id={'main'} className={'main-primary'}>
          {/* Banner removed as requested */}
          <div id="emsa-programs">
            <Routes>
              {/* Direct tab routes */}
              {Object.entries(ROUTE_CONFIG).map(([path, config]) => (
                <Route
                  key={path}
                  path={path}
                  element={<EMSATrainingPrograms initialPage={config.page} initialTab={config.tab} />}
                />
              ))}
              
              {/* Default route - redirect to continuing education */}
              <Route path="/" element={<Navigate to="/continuing-education" replace />} />
              
              {/* Catch all route */}
              <Route path="*" element={<EMSATrainingPrograms initialPage={1} initialTab={0} />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
